import React from 'react';
import {
  Box,
  makeStyles,
} from '@material-ui/core';
import { Spinner } from 'src/components/Loaders';
import PlainLayout from '../../layouts/PlainLayout';

const useStyles = makeStyles((theme) => ({
  spinnerBox : {
    position:"relative",
    paddingTop:64,
    flex:1,
    display:"flex",
    alignItems:"center",
    justifyContent:"center"
  }
}));


const LoadingWithPlainLayoutScreen: React.FC = () => {

  const classes = useStyles();
  return (
    <PlainLayout>
      <Box className={classes.spinnerBox}>
        <Spinner/>
      </Box>
    </PlainLayout>
  )
}

export default LoadingWithPlainLayoutScreen;
